// extracted by mini-css-extract-plugin
export default {"container":"waterbody_follow_button_logged_in__container--INFB"};